<template>
  <div
    id="main-wrapper"
    data-theme="light"
    data-layout="vertical"
    data-navbarbg="skin6"
    :data-sidebartype="$store.state.data_sidebartype"
    data-sidebar-position="fixed"
    data-header-position="fixed"
    data-boxed-layout="full"
  >
    <HeaderView />
    <SliderView />
    <div class="page-wrapper" style="display: block;">
      <div class="container-fluid">
        <BreadcrumbView />
        <router-view></router-view>
      </div>
      <FooterView />
    </div>
    <a-back-top>
      <div class="ant-back-top-inner">
        <i class="fas fa-angle-up"></i>
      </div>
    </a-back-top>
    <div class="modal fade" id="menuMobileOnly" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="menuMobileOnlyLabel" aria-hidden="true">
      <div class="modal-dialog modal-fullscreen modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header d-flex flex-column justify-content-center align-items-center">
            <img src="../assets/logo.png" width="180" />
            <small>Stock Taking</small>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 70vh;">
              <div class="row justify-content-center" style="width: 100%;">
                <div class="col-11 d-grid gap-2">
                  <button type="button" class="btn waves-effect waves-light btn-light-info text-info" style="padding: 20px; margin-bottom: 10px;" data-bs-dismiss="modal">MAINMENU</button>
                  <button type="button" class="btn waves-effect waves-light btn-light-info text-info" style="padding: 20px;" data-bs-dismiss="modal" @click="$router.push('/inspect')">
                    STOCK TAKING
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './header_view'
import SliderView from './slider_view'
import FooterView from './footer_view'
import BreadcrumbView from './breadcrumb_view'
export default {
  name: 'Main',
  components: {
    HeaderView,
    FooterView,
    SliderView,
    BreadcrumbView
  },
  mounted() {
    if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      if (this.$route.path !== '/inspect') {
        this.ModalBoots('menuMobileOnly').show()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main.vue